import $ from 'jquery';
import 'slick-carousel';

const Sliders = {

    init() {

		const $productImageSlider = $('.js-product-image-slider');
		const $productThumbnailsSlider = $('.js-product-thumbnails-slider');
		const $howItWorksSlider = $('.js-how-it-works-slider');
		const $howItWorksAltSlider = $('.js-how-it-works-slider-alt');
		const $whyChooseUsSlider = $('.js-why-choose-us-slider');
		const $featuredProductSlider = $('.js-featured-product-slider');
		const $crosssellsSlider = $('.js-crosssells-slider');
		const $faqsSlider = $('.js-faqs-slider');
		const $cardGridSlider = $('.js-card-grid-slider');
		const $testimonialSlider = $('.js-testimonial-slider');
		
		$productImageSlider.slick({
			rows: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $productImageSlider.find('.js-slider-prev-button'),
			nextArrow: $productImageSlider.find('.js-slider-next-button'),
			fade: true,
			slide: '.js-slide',
			asNavFor: $productThumbnailsSlider,
			responsive: [
				{
					breakpoint: 800,
					settings: {
						arrows: true,						
						asNavFor: false,
					}
				}
			]
		});
		
		$productThumbnailsSlider.slick({
			rows: 0,
			slidesToShow: 3,
			asNavFor: $productImageSlider,
			focusOnSelect: true,
			dots: false,
			slide: '.js-slide',
			prevArrow: $productThumbnailsSlider.find('.js-slider-prev-button'),
			nextArrow: $productThumbnailsSlider.find('.js-slider-next-button'),
			responsive: [
				{
					breakpoint: 800,
					settings: 'unslick'
				}
			]
		});

		$cardGridSlider.slick({
			rows: 0,
			slidesToShow: 3,
			dots: true,
			dotsClass: 'slick-dots slick-dots--alt',
			slide: '.js-slide',
			arrows: true,
			prevArrow: $cardGridSlider.find('.js-slider-prev-button'),
			nextArrow: $cardGridSlider.find('.js-slider-next-button'),
			responsive: [
				{
					breakpoint: 1020,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 1,
						adaptiveHeight: true,
					}
				},
			]
		});

		$howItWorksSlider.slick({
			rows: 0,
			slidesToShow: 4,
			arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 1020,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 1,
					}
				},
			]
		});

		$howItWorksAltSlider.slick({
			rows: 0,
			slidesToShow: 4,
			arrows: false,
			dots: true,
			slide: '.js-slide',
			responsive: [
				{
					breakpoint: 1020,
					settings: {
						slidesToShow: 2,
						arrows: true,
						prevArrow: $howItWorksAltSlider.find('.js-slider-prev-button'),
						nextArrow: $howItWorksAltSlider.find('.js-slider-next-button'),
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 1,
						arrows: true,
						prevArrow: $howItWorksAltSlider.find('.js-slider-prev-button'),
						nextArrow: $howItWorksAltSlider.find('.js-slider-next-button'),
					}
				},
			]
		});

		$crosssellsSlider.each(function() {
			const $slider = $(this);
			const settings = {
				rows: 0,
				dots: true,
				slidesToShow: 2,
				slide: '.product-card',
				prevArrow: $slider.find('.js-slider-prev-button'),
				nextArrow: $slider.find('.js-slider-next-button'),
				responsive: [
					{
						breakpoint: 1100,
						arrows: false,
						settings: {
							slidesToShow: 1,
						}
					},
				]
			};
			$slider.slick(settings);
		});

		$whyChooseUsSlider.slick({
			rows: 0,
			slidesToShow: 4,
			arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 1020,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 1,
					}
				},
			]
		});

		$featuredProductSlider.slick({
			rows: 0,
			slidesToShow: 3,
			arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 1,
					}
				},
			]
		});

		$faqsSlider.slick({
			rows: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			slide: '.js-slide',
			prevArrow: $faqsSlider.find('.js-slider-prev-button'),
			nextArrow: $faqsSlider.find('.js-slider-next-button'),
			dots: true,
			dotsClass: 'slick-dots c-faqs-slider__slick-dots',
			adaptiveHeight: true
		});

		$testimonialSlider.each(function() {
			$(this).slick({
				rows: 0,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				slide: '.js-slide',
				prevArrow: $(this).find('.js-slider-prev-button'),
				nextArrow: $(this).find('.js-slider-next-button'),
				dots: false,
				adaptiveHeight: true,
			});
		});
    }
}

export default Sliders;